import * as React from 'react';
import Box from '@mui/material/Box';

const ContentWrapper = ({children, isMobile, className}) => {
    
    return (
        <Box component="main" className={isMobile ? 'content-wrapper-mobile ' + className : 'content-wrapper ' + className}>
            <Box className={isMobile? 'content-container-mobile' : 'content-container'}>
                {children}
            </Box>
        </Box>
    );
};

export default ContentWrapper;